"use strict";

import * as Video from "components/Video";
import * as Modals from "components/Modals";
import * as VideoSlider from "components/VideoSlider";
document.addEventListener("DOMContentLoaded", function () {
  Video.init();
  Modals.init();
  VideoSlider.init();
});
window.addEventListener("load", function () {});
